import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import DoneIcon from "@mui/icons-material/Done";
import "../NewConnection/NewConnectionForm.scss";
import { cfpBaseUrl } from "../../../network/urls";
import { useLocation } from "react-router";
import { handleFileUpload } from "../../../services/Functions";
import { CircularProgress, Backdrop } from "@mui/material";
import Error from "../../../components/error/error";
import { useSelector } from "react-redux";
import { documentExtensions, portalName } from "../../../utils/PortalName";
import { Alert, Snackbar } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import PrintIcon from "@mui/icons-material/Print";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";


const ReconnectionUpdate = () => {
  const initialValues = {
    // Required Documents Initial Values
    iv_applicant_cnic_document_front: null,
    iv_applicant_cnic_document_back: null,
  };
  const [openAlert, setOpenAlert] = useState(false);
  const [alertData, setAlertData] = useState({
    type: "success",
    message: "",
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  // Documents states
  const [applicantCnicDocumentFront, setApplicantCnicDocumentFront] =
    useState("");
  const [applicantCnicDocumentBack, setApplicantCnicDocumentBack] =
    useState("");
  // Thumbnail states
  const [
    applicantCnicDocumentFrontThumbnail,
    setApplicantCnicDocumentFrontThumbnail,
  ] = useState("");
  const [
    applicantCnicDocumentBackThumbnail,
    setApplicantCnicDocumentBackThumbnail,
  ] = useState("");

  const [applicantCnicFrontError, setApplicantCnicFrontError] = useState("");
  const [applicantCnicBackError, setApplicantCnicBackError] = useState("");

  const [connectionType, setConnectionType] = useState();
  const [applicantStatus, setApplicantStatus] = useState();
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const { state } = useLocation();
  const { dialogRowData } = state;
  const [dialogRowDataLocal, setDialogRowDataLocal] = useState();
  let { token, userId } = useSelector((state) => state.auth);
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (dialogRowData) {
      let dialogData = dialogRowData;
      setDialogRowDataLocal(dialogData);
    }
  }, [dialogRowData]);

  useEffect(() => {
    if (dialogRowData.applicantCNICFront) {
      values.iv_applicant_cnic_document_front =
        dialogRowData.applicantCNICFront;
      setApplicantCnicDocumentFrontThumbnail(dialogRowData.applicantCNICFront);
    }
    if (dialogRowData.applicantCNICBack) {
      values.iv_applicant_cnic_document_back = dialogRowData.applicantCNICBack;
      setApplicantCnicDocumentBackThumbnail(dialogRowData.applicantCNICBack);
    }
  }, [dialogRowData]);

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema: Yup.object({
        // Required Documents Validation
        iv_applicant_cnic_document_front: Yup.mixed().required(
          "Please upload cnic in jpg, jpeg, png or pdf format."
        ),
        iv_applicant_cnic_document_back: Yup.mixed().required(
          "Please upload cnic in jpg, jpeg, png or pdf format."
        ),
      }),
      onSubmit: async (values, { resetForm }) => {
        setViewBackdrop(true);

        try {
          const myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          myHeaders.append("Authorization", token);

          const raw = JSON.stringify({
            applicationId: dialogRowData.applicationId,
            submittedThrough: portalName,
            applicationProgressId: 1,
            objectionStatus: 0,
            applicantCNICBack: applicantCnicDocumentBackThumbnail,
            applicantCNICFront: applicantCnicDocumentFrontThumbnail,
            paidBillImage: "",
            applicantCNICFrontFlag: 2,
            applicantCNICBackFlag: 2,
            paidBillImageFlag: 2,
            remarksDetails: "Documents Re-uploaded.",
            remarks: "Documents Re-uploaded.",
          });

          const response = await fetch(
            `${cfpBaseUrl}rco/reUploadRCODocuments`,
            {
              method: "POST",
              headers: myHeaders,
              body: raw,
            }
          );

          const result = await response.json();

          if (result?.status === 200 || result?.status === "200") {
            setSnackbar({
              open: true,
              message: result?.message || "Documents re-uploaded successfully",
              severity: "success",
            });

            resetForm(); // ✅ reset form after success
          } else {
            setSnackbar({
              open: true,
              message: result?.message || "Something went wrong",
              severity: "error",
            });
          }
        } catch (error) {
          console.error(error);
          setSnackbar({
            open: true,
            message: "Server error. Please try again.",
            severity: "error",
          });
        } finally {
          setViewBackdrop(false); // ✅ ALWAYS stop loader
        }
      },
    });

  const handleSnackbarClose = (severity) => {
  setSnackbar({ ...snackbar, open: false });

  if (severity === "success") {
    navigate("/reconnection-table");
  }
};

  //Function to set states of documents

  const ApplicantCnicDocumentFront = (event) => {
    const newFileName =
      "copyOfApplicantCNICFront." + event.target.files[0].name.split(".").pop();
    handleFileUpload(
      event,
      handleChange,
      setApplicantCnicDocumentFront,
      setApplicantCnicFrontError,
      setApplicantCnicDocumentFrontThumbnail,
      newFileName
    );
  };

  const ApplicantCnicDocumentBack = (event) => {
    const newFileName =
      "copyOfApplicantCNICBack." + event.target.files[0].name.split(".").pop();
    handleFileUpload(
      event,
      handleChange,
      setApplicantCnicDocumentBack,
      setApplicantCnicBackError,
      setApplicantCnicDocumentBackThumbnail,
      newFileName
    );
  };

  const errorCloses = () => {
    setError("");
  };

  return (
    <>
      <Grid container className="nC">
        <Box className="nCContainer">
          <Typography variant="h6" className="heading">
            New Connection Form
          </Typography>
          <Box className="progressBarBackground">
            <Box className="progressBarContainer">
              <Box className="pbDocGroup">
                <Typography className="badge">
                  {(dialogRowData.applicantCNICFront &&
                    dialogRowData.applicantCNICBack) ||
                  (applicantCnicDocumentFront && applicantCnicDocumentBack) ? (
                    <Box className="backgroundAttached">
                      <DoneIcon className="icon" />
                    </Box>
                  ) : (
                    <p className="backgroundUnAttached">1</p>
                  )}
                </Typography>
                <Typography className="badgeText">Applicant's CNIC.</Typography>
              </Box>
            </Box>
          </Box>
          <form className="ncform">
            <Typography variant="h6" className="groupTitle">
              Application Details
            </Typography>
            <Grid container spacing={1} sx={{margin:'1.25%'}}>
              <Grid item xs={2}>
                <Typography className="fieldLabel"> Application Id</Typography>
                <TextField
                  required
                  type="text"
                  name="iv_applied_load"
                  value={dialogRowData.applicationId}
                  disabled
                  id="iv_applied_load"
                  className="textInputField"
                />
              </Grid>
              <Grid item xs={2}>
                <Typography className="fieldLabel"> Connection Type</Typography>
                <TextField
                  autoWidth={false}
                  value={dialogRowData.connectionCategory}
                  disabled
                  className="textInputField"
                  name="iv_connection_type"
                  id="iv_connection_type"
                />
              </Grid>
              <Grid item xs={3}>
                <Typography className="fieldLabel">Applicant Status</Typography>
                <TextField
                  type="double"
                  name="iv_near_by_reference_no"
                  value={dialogRowData.applicantStatus}
                  disabled
                  id="iv_near_by_reference_no"
                  className="textInputField"
                />
              </Grid>
            </Grid>
            <Typography variant="h6" className="groupTitle">
              Documents
            </Typography>
            <Grid container spacing={1} className="documentsContainer" sx={{margin:'1.25%'}}>
              <Grid item lg="2">
                <Typography className="documentLabel">
                  1- Applicant's CNIC.
                </Typography>
                <Box className="documentError">
                  {(errors.iv_applicant_cnic_document_front &&
                    touched.iv_applicant_cnic_document_front) ||
                  (errors.iv_applicant_cnic_document_back &&
                    touched.iv_applicant_cnic_document_back)
                    ? errors.iv_applicant_cnic_document_front
                    : null}
                </Box>
              </Grid>
              <Grid item lg="1">
                {dialogRowData.applicantCNICFront ? (
                  <Grid container>
                    <Grid item sm={6}>
                      <img
                        src={applicantCnicDocumentFrontThumbnail}
                        style={{ width: "50%" }}
                      />
                    </Grid>
                    {(!dialogRowData.applicantCNICFrontFlag ||
                      dialogRowData.applicantCNICFrontFlag === "-1") && (
                      <Grid item sm={6}>
                        <Button
                          varient="outlined"
                          component="label"
                          startIcon={
                            <DeleteOutlinedIcon sx={{ color: "red" }} />
                          }
                        >
                          Change
                          <input
                            hidden
                            accept={documentExtensions}
                            id="iv_applicant_cnic_document_front"
                            name="iv_applicant_cnic_document_front"
                            type="file"
                            onChange={ApplicantCnicDocumentFront}
                          />
                        </Button>
                        <Box className="documentError">
                          {applicantCnicFrontError}
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                ) : applicantCnicDocumentFront ? (
                  <>
                    <Button
                      varient="outlined"
                      component="label"
                      startIcon={
                        <DeleteOutlinedIcon
                          sx={{ color: "red" }}
                          onClick={() => {
                            setApplicantCnicDocumentFront("");
                          }}
                        />
                      }
                    >
                      {applicantCnicDocumentFrontThumbnail && (
                        <img
                          src={applicantCnicDocumentFrontThumbnail}
                          alt="Applicant CNIC"
                          width="50"
                        />
                      )}
                    </Button>
                    <Box className="documentError">
                      {applicantCnicFrontError}
                    </Box>
                  </>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<FileUploadOutlinedIcon />}
                    >
                      Front
                      <input
                        hidden
                        accept={documentExtensions}
                        id="iv_applicant_cnic_document_front"
                        name="iv_applicant_cnic_document_front"
                        type="file"
                        onChange={ApplicantCnicDocumentFront}
                      />
                    </Button>
                    <Box className="documentError">
                      {applicantCnicFrontError}
                    </Box>
                  </>
                )}
              </Grid>
              <Grid item lg="1">
                {dialogRowData.applicantCNICBack ? (
                  <Grid container>
                    <Grid item sm={6}>
                      <img
                        src={applicantCnicDocumentBackThumbnail}
                        style={{ width: "50%" }}
                      />
                    </Grid>
                    {(!dialogRowData.applicantCNICBackFlag ||
                      dialogRowData.applicantCNICBackFlag === "-1") && (
                      <Grid item sm={6}>
                        <Button
                          varient="outlined"
                          component="label"
                          startIcon={
                            <DeleteOutlinedIcon sx={{ color: "red" }} />
                          }
                        >
                          Change
                          <input
                            hidden
                            accept={documentExtensions}
                            id="iv_applicant_cnic_document_back"
                            name="iv_applicant_cnic_document_back"
                            type="file"
                            onChange={ApplicantCnicDocumentBack}
                          />
                        </Button>
                        <Box className="documentError">
                          {applicantCnicBackError}
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                ) : applicantCnicDocumentBack ? (
                  <>
                    <Button
                      varient="outlined"
                      component="label"
                      startIcon={
                        <DeleteOutlinedIcon
                          sx={{ color: "red" }}
                          onClick={() => {
                            setApplicantCnicDocumentBack("");
                          }}
                        />
                      }
                    >
                      {applicantCnicDocumentBackThumbnail && (
                        <img
                          src={applicantCnicDocumentBackThumbnail}
                          alt="Applicant CNIC Back"
                          width="50"
                        />
                      )}
                    </Button>
                    <Box className="documentError">
                      {applicantCnicBackError}
                    </Box>
                  </>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<FileUploadOutlinedIcon />}
                      className="btn"
                    >
                      Back
                      <input
                        hidden
                        accept={documentExtensions}
                        id="iv_applicant_cnic_document_back"
                        name="iv_applicant_cnic_document_back"
                        type="file"
                        onChange={ApplicantCnicDocumentBack}
                      />
                    </Button>
                    <Box className="documentError">
                      {applicantCnicBackError}
                    </Box>
                  </>
                )}
              </Grid>
            </Grid>
            {error && (
              <Error
                error={error}
                onClose={() => errorCloses()}
                backgroundColor="#FFC0CB"
                textColor="#bb0303"
                iconColor="#bb0303"
              />
            )}
            <Box sx={{ marginTop: "18%", textAlign: "right" }}>
              <Button
                sx={{ width: "10%", marginLeft: "1%", marginBottom: "1%" }}
                variant="contained"
                component="label"
                type="submit"
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </Box>
          </form>
        </Box>
      </Grid>

      {/* <Snackbar
        open={openAlert}
        autoHideDuration={4000}
        onClose={() => setOpenAlert(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          severity={alertData.type}
          variant="filled"
          onClose={() => setOpenAlert(false)}
        >
          {alertData.message}
        </Alert>
      </Snackbar> */}

      <Dialog
  open={snackbar.open}
  onClose={() => handleSnackbarClose(snackbar.severity)} // ✅ Fixed: Now calls handler with severity
  maxWidth="xs"
  fullWidth
  PaperProps={{
    sx: {
      borderRadius: 3,
      textAlign: "center",
      padding: 2,
    },
  }}
>
  {/* <IconButton
    onClick={() => handleSnackbarClose(snackbar.severity)} 
    sx={{
      position: "absolute",
      right: 8,
      top: 8,
      color: (theme) => theme.palette.grey[500],
    }}
  >
    <CloseIcon /> 
  </IconButton> */}

  <DialogContent>
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        py: 2,
      }}
    >
      {snackbar.severity === "success" ? (
        <CheckCircleIcon
          sx={{
            fontSize: "2.5rem",
            color: "#2e7d32",
          }}
        />
      ) : (
        <ErrorIcon
          sx={{
            fontSize: "2.5rem",
            color: "#d32f2f",
          }}
        />
      )}

      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          color: snackbar.severity === "success" ? "#2e7d32" : "#d32f2f",
        }}
      >
        {snackbar.severity === "success" ? "Success!" : "Error!"}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: snackbar.severity === "success" ? "#444" : "red",
          px: 2,
          fontSize: "1.5rem",
        }}
      >
        {snackbar.message}
      </Typography>
    </Box>
  </DialogContent>
</Dialog>
      {/* Backdrop */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default ReconnectionUpdate;
